import React from 'react';
import { Award, DollarSign, CheckCircle } from 'lucide-react';
import internshipImage from '../assets/internship-image.png';
import './Internship.css';

const Internship = () => {
  return (
    <section id="internship" className="internship">
  <div className="internship-container">
    
    {/* Image Section */}
    <div className="internship-image-wrapper animate-fade-in-up">
      <img 
        src={internshipImage} 
        alt="Internship Program" 
        className="internship-image" 
      />
    </div>

    {/* Content Section */}
    <div className="internship-content">
      <div className="internship-badge">Exclusive Offer</div> {/* Moved inside content */}
      
      <h2 className="internship-title animate-fade-in-up">
        Kickstart Your Career with Codex{' '}
        <span className="internship-highlight">Internship</span> Programs!
      </h2>

      <p className="internship-description animate-fade-in-up animate-delay-100">
        Take advantage of this chance to enhance your skills while getting paid! Codex Future offers guaranteed 
        internships with stipends of up to ₹8,000 per month, helping you gain real-world experience and 
        jump-start your IT career. Don't miss out on this rewarding opportunity!
      </p>

      <div className="internship-features">
        {/* Feature 1 */}
        <div className="internship-feature animate-fade-in-up animate-delay-200">
          <div className="feature-icon">
            <Award size={32} />
          </div>
          <div className="feature-content">
            <h3 className="feature-title">100% Internship Guaranteed!</h3>
            <p className="feature-description">Crack our CGPA test to secure your internship!</p>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="internship-feature animate-fade-in-up animate-delay-300">
          <div className="feature-icon">
            <DollarSign size={32} />
          </div>
          <div className="feature-content">
            <h3 className="feature-title">Stipend Up to ₹8,000/month!</h3>
            <p className="feature-description">Get Paid While You Learn: Stipend Up to ₹8,000/Month!</p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <a href="/contact" className="internship-cta animate-fade-in-up animate-delay-400">
        <CheckCircle size={20} />
        Quick Join Now
      </a>
    </div>
  </div>
</section>

  );
};

export default Internship;
